// GoHighLevel CRM integration
export const submitToGoHighLevel = async (formData) => {
  const GHL_API_TOKEN = process.env.REACT_APP_GHL_API_TOKEN;
  const GHL_API_URL = process.env.REACT_APP_GHL_API_URL;
  
  if (!GHL_API_TOKEN || !GHL_API_URL) {
    throw new Error('GoHighLevel API configuration missing');
  }
  
  try {
    const response = await fetch(GHL_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${GHL_API_TOKEN}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        companyName: formData.company,
        customFields: {
          revenue_range: formData.currentRevenue,
          intent_level: formData.intent,
          message: formData.message,
          source: 'B2B Rev Co Website'
        },
        tags: ['website-lead', 'email-list-signup']
      })
    });

    if (!response.ok) {
      throw new Error(`GoHighLevel API error: ${response.status}`);
    }

    const result = await response.json();
    console.log('GoHighLevel submission successful:', result);
    
    return {
      id: result.contact?.id || `lead_${Date.now()}`,
      status: 'success',
      message: 'Contact successfully added to GoHighLevel CRM',
      contact: result.contact
    };
    
  } catch (error) {
    console.error('GoHighLevel submission error:', error);
    throw new Error('Failed to add contact to CRM - please try again');
  }
};

// Zapier webhook integration for notifications
export const sendToZapier = async (formData) => {
  const ZAPIER_WEBHOOK_URL = process.env.REACT_APP_ZAPIER_WEBHOOK_URL;
  
  if (!ZAPIER_WEBHOOK_URL || ZAPIER_WEBHOOK_URL === 'YOUR_ZAPIER_WEBHOOK_URL_HERE') {
    console.log('Zapier webhook URL not configured - skipping notification');
    return { status: 'skipped', message: 'Zapier not configured' };
  }
  
  try {
    const response = await fetch(ZAPIER_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        company: formData.company,
        currentRevenue: formData.currentRevenue,
        intent: formData.intent,
        message: formData.message,
        timestamp: new Date().toISOString(),
        source: 'B2B Rev Co Website',
        fullName: `${formData.firstName} ${formData.lastName}`,
        // Formatted message for Slack/notifications
        notificationMessage: `🚨 New Lead: ${formData.firstName} ${formData.lastName} (${formData.company}) - Intent: ${formData.intent} - Revenue: ${formData.currentRevenue}`
      })
    });

    if (!response.ok) {
      throw new Error(`Zapier webhook failed: ${response.status}`);
    }

    console.log('Zapier notification sent successfully');
    return { status: 'success', message: 'Notification sent' };
    
  } catch (error) {
    console.error('Zapier notification error:', error);
    // Don't fail the whole process if Zapier fails
    return { status: 'error', message: error.message };
  }
};

// Mock data for development
export const mockLeads = [
  {
    id: 'lead_1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john@techcorp.com',
    company: 'TechCorp Solutions',
    phone: '+1-555-0123',
    currentRevenue: '$1M - $5M',
    message: 'Looking to scale our sales team without hiring full-time reps.',
    createdAt: '2024-01-15T10:30:00Z',
    status: 'contacted'
  },
  {
    id: 'lead_2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah@growthco.com',
    company: 'Growth Co',
    phone: '+1-555-0456',
    currentRevenue: '$500k - $1M',
    message: 'Our current sales process is inconsistent. Need help closing deals.',
    createdAt: '2024-01-14T14:15:00Z',
    status: 'scheduled'
  }
];